<ng-content select="spt-help-content-header,spt-help-tooltip-header"></ng-content>
<mat-divider *ngIf="showDivider" class="push-top-10 push-left-20 push-right-20"></mat-divider>
<ng-content select="spt-help-content-body "></ng-content>
